import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pointPos",
  "use": "icon-pointPos-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-pointPos\">\r\n<circle cx=\"12\" cy=\"12\" r=\"12\" fill=\"currentColor\" />\r\n<path d=\"M13.7363 6C15.9839 6.00027 17.5 7.89836 17.5 10C17.5 12.1016 15.9839 13.9997 13.7363 14H10.5V18H7.5V6H13.7363ZM10.5 11H13.7363C14.0545 10.9997 14.5 10.7312 14.5 10C14.5 9.26882 14.0545 9.00027 13.7363 9H10.5V11Z\" fill=\"white\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol